import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { MailIcon, LockIcon, EyeIcon, EyeOffIcon } from 'lucide-react';
const Login = () => {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errors, setErrors] = useState<{
    email?: string;
    password?: string;
  }>({});
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const newErrors: {
      email?: string;
      password?: string;
    } = {};
    if (!email) {
      newErrors.email = 'El correo electrónico es requerido';
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      newErrors.email = 'Ingresa un correo electrónico válido';
    }
    if (!password) {
      newErrors.password = 'La contraseña es requerida';
    }
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    // Aquí iría la lógica de autenticación
    console.log('Login:', {
      email,
      password
    });
    navigate('/');
  };
  return <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4" data-id="element-1756">
      <div className="w-full max-w-md" data-id="element-1757">
        <div className="bg-white rounded-2xl shadow-xl p-8" data-id="element-1758">
          {/* Logo and Title */}
          <div className="text-center mb-8" data-id="element-1759">
            <h1 className="text-3xl font-bold text-blue-600 mb-2" data-id="element-1760">
              FinancePro
            </h1>
            <p className="text-gray-600" data-id="element-1761">Inicia sesión en tu cuenta</p>
          </div>
          {/* Form */}
          <form onSubmit={handleSubmit} className="space-y-5" data-id="element-1762">
            {/* Email Field */}
            <div data-id="element-1763">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1764">
                Correo electrónico
              </label>
              <div className="relative" data-id="element-1765">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-1766">
                  <MailIcon size={18} className="text-gray-400" data-id="element-1767" />
                </div>
                <input type="email" value={email} onChange={e => {
                setEmail(e.target.value);
                setErrors({
                  ...errors,
                  email: undefined
                });
              }} className={`w-full pl-10 pr-4 py-2.5 border ${errors.email ? 'border-red-500' : 'border-gray-300'} rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all`} placeholder="tu@email.com" data-id="element-1768" />
              </div>
              {errors.email && <p className="text-red-500 text-xs mt-1" data-id="element-1769">{errors.email}</p>}
            </div>
            {/* Password Field */}
            <div data-id="element-1770">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1771">
                Contraseña
              </label>
              <div className="relative" data-id="element-1772">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-1773">
                  <LockIcon size={18} className="text-gray-400" data-id="element-1774" />
                </div>
                <input type={showPassword ? 'text' : 'password'} value={password} onChange={e => {
                setPassword(e.target.value);
                setErrors({
                  ...errors,
                  password: undefined
                });
              }} className={`w-full pl-10 pr-12 py-2.5 border ${errors.password ? 'border-red-500' : 'border-gray-300'} rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all`} placeholder="••••••••" data-id="element-1775" />
                <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute inset-y-0 right-0 pr-3 flex items-center" data-id="element-1776">
                  {showPassword ? <EyeOffIcon size={18} className="text-gray-400 hover:text-gray-600" data-id="element-1777" /> : <EyeIcon size={18} className="text-gray-400 hover:text-gray-600" data-id="element-1778" />}
                </button>
              </div>
              {errors.password && <p className="text-red-500 text-xs mt-1" data-id="element-1779">{errors.password}</p>}
            </div>
            {/* Remember Me and Forgot Password */}
            <div className="flex items-center justify-between" data-id="element-1780">
              <label className="flex items-center" data-id="element-1781">
                <input type="checkbox" className="h-4 w-4 text-blue-600 rounded border-gray-300 focus:ring-2 focus:ring-blue-500" data-id="element-1782" />
                <span className="ml-2 text-sm text-gray-600" data-id="element-1783">Recordarme</span>
              </label>
              <Link to="/forgot-password" className="text-sm text-blue-600 hover:text-blue-700 font-medium" data-id="element-1784">
                ¿Olvidaste tu contraseña?
              </Link>
            </div>
            {/* Submit Button */}
            <button type="submit" className="w-full bg-blue-600 text-white py-2.5 rounded-lg hover:bg-blue-700 transition-colors font-medium" data-id="element-1785">
              Iniciar sesión
            </button>
          </form>
          {/* Register Link */}
          <div className="mt-6 text-center" data-id="element-1786">
            <p className="text-sm text-gray-600" data-id="element-1787">
              ¿No tienes una cuenta?{' '}
              <Link to="/register" className="text-blue-600 hover:text-blue-700 font-medium" data-id="element-1788">
                Regístrate
              </Link>
            </p>
          </div>
        </div>
        {/* Footer */}
        <div className="text-center mt-6" data-id="element-1789">
          <p className="text-sm text-gray-600" data-id="element-1790">
            © 2024 FinancePro. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </div>;
};
export default Login;